import { usePageDataStore } from '@mc/globalStore';
import destructiveRead from '@mc/page-data';

// TODO temporary function. Remove after globalStore is migrated to TS / our flag is rolled out
const getConfigFromPageDataStore = () => {
  if (usePageDataStore) {
    return usePageDataStore.getState().appConfig;
  }
};
const config = window.xp_page_data_async
  ? getConfigFromPageDataStore()
  : destructiveRead('js-app-config');

export default config;
